import request from '@/utils/request'
const apiPath = '/cust/managecustomerwallet'
const managecustomerwalletApi = {
  /**
   * 新增修改【客户证件】
   */
  create(data) {
    return request.post(`${apiPath}/saveorupdate`, data)
  },
  giveOrDeductionMoneyList(data) {
    return request.post(`${apiPath}/giveOrDeductionMoneyList`, data)
  },
  /**
   * 分页查询【财务管理-账户管理-佣金】
   */
  fetchList(query) {
    return request.get(`${apiPath}/findCustomerCommissionPage`, { params: query })
  },
  getReasonListByType(id,moneyType) {
    return request.get(`${apiPath}/getReasonListByType/${id}/${moneyType}`)
  },
  /**
   * 分页查询【财务管理-账户管理-余额-零售价-赠送账户-积分 】
   */
  fetchListPage(query) {
    return request.get(`${apiPath}/findFinanceCustomerWalletPage`, { params: query })
  },
  /**
   * 分页查询【财务管理-账户管理-佣金-佣金明细 】
   */
  fetchDetailList(query) {
    return request.get(`${apiPath}/findCustomerCommissionDetailPage`, { params: query })
  },
  /**
   * 分页查询【财务管理-账户管理-余额-零售价-赠送账户-积分 ---明细 】
   */
  fetchListDetailPage(query) {
    return request.get(`${apiPath}/findFinanceCustomerWalletDetailPage`, { params: query })
  },
  /**
   * 【合作方账户异常账户统计】
   */
  getStatistics(){
     return request.get(`${apiPath}/findManageAreaWalletTotal`)
  },
  // 查询所有有效的大区
  findAreaCustomerList(query){
    return request.get(`${apiPath}/findAreaCustomerList`,{ params: query })
  },
  // 赠送-扣减额度
  giveOrDeductionMoney(query){
    return request.get(`${apiPath}/GiveOrDeductionMoney`,{ params: query })
  },
  // 业务管理-查询单个用户佣金统计信息
  findCommissionTotalByCustomerId(query){
    return request.get(`${apiPath}/findCommissionTotalByCustomerId`,{ params: query })
  },
  exportExcel(data){
    return request.post(apiPath + '/manageFinanceAccountExport', data)
  },
  exportRefundDetail(data){
    return request.post(apiPath + '/manageFinanceRefundDetailExport', data)
  },
  // 获取账号类型对应的身份级别列表
  findCustomerWalletTypeShow(){
    return request.get(`${apiPath}/findCustomerWalletTypeShow`)
  },
  findManageFinanceCommissionStatic(query){
    return request.get(`${apiPath}/findManageFinanceCommissionStatic`,{ params: query })
  },
  // 更新明细原因与金额（新增接口，需后端支持）
  updateWalletDetail(data){
    return request.post(`${apiPath}/updateWalletDetail`, data)
  },
}
export default managecustomerwalletApi
